import { Card } from 'antd';
import styled from 'styled-components';

export const FilterActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  width: 100%;
`;

export const PopOverWrapper = styled.div`
  min-width: 250px;
`;

export const PopOverItem = styled.div`
  > div {
    padding: .25rem .75rem;
    display: flex;
    justify-content: space-between;

    > div {
      display: flex;
      gap: 5px;

      > span {
        font-size: 1.125rem;
      }

      > button {
        border: 0;
        background-color: transparent;
        background-image: none;
        cursor: pointer;
      }
    }
  }

  > .checkboxes-wrapper {
    flex-direction: column;
  }
`;

export const NoDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  margin-top: 2rem;
  gap: 10px;
`;

export const CommunityCard = styled(Card)`
  min-height: 400px;
  margin-top: 10px;
  max-width: 18rem;
  box-shadow: 2px 2px 15px 0px #0000001A;
  cursor: pointer;

  .ant-card-body {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    padding: 16px;

    > div {
      .user-info {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .community-image {
        margin-top: 10px;
        > .ant-image {
          width: 100%;
        }
      }

      .community-info {
        > .general-text {
          font-weight: 500;
          color: #319795;
          font-size: 14px;
        }

        > .title {
          font-size: 20px;
          font-weight: bold;
        }

        > .category {
          font-size: 14px;
          text-transform: uppercase;
        }

        > .description {
          color: #A6A6A6;
          font-size: 14px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .community-tags {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        gap: 3px;
        margin-top: 8px;
      }

      .community-actions {
        display: flex;
        justify-content: space-between;
        gap: 10px;

        > .icon-container {
          display: flex;
          align-items: center;
          gap: 8px;
        }
      }
    }
  }
`;

export const CommunityTag = styled.div`
  padding: .25rem .5rem;
  margin-bottom: .5rem;
  background-color: #e2e8f0;
  border-radius: .5rem;
`;

export const DivWrapper = styled.div`
  display: flex;
  flex-direction: column;

  > .ant-checkbox-group {
    flex-direction: column;
  }
`;